var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stars"}},_vm._l((_vm.star_num),function(item,index){return _c('div',{key:index,ref:"star",refInFor:true,staticClass:"star"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }